export default {
  errors: [],
  products: [],
  loading: false
};
